import { render } from "./OrderInfo.vue?vue&type=template&id=7d12d330&scoped=true"
import script from "./OrderInfo.vue?vue&type=script&lang=js"
export * from "./OrderInfo.vue?vue&type=script&lang=js"

import "./OrderInfo.vue?vue&type=style&index=0&id=7d12d330&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d12d330"]])

export default __exports__